export const coreAddresses = {
  balanceTracker: "0x70Fb24bDa46E7cFD447C64bB32180Bc746ba3A71",
  eVaultFactory: "0x5C13fb43ae9BAe8470f646ea647784534E9543AF",
  eVaultImplementation: "0x402598Ac4034D24f2cB37BDb0721A67365aD19BD",
  eulerEarnFactory: "0x9cbc3030e6d133D1AAa148D598FD82D70263495c",
  evc: "0x45334608ECE7B2775136bC847EB92B5D332806A9",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0x51432af61A715DB3D0f20A3691C1E25F9A2c6B05",
  sequenceRegistry: "0x0c9a75E05764775A0cF52bC6cbfE6Cb229bb3901",
} as const
